export default {
  have_account: 'Hast du schon ein Konto?',
  sign_in: 'Anmelden',
  sign_in_description: 'um deine Punkte & gespeicherten Infos zu nutzen',
  join_free: 'Kostenlos registrieren',
  join_description: '— sammle Prämien bei jeder Bestellung',
  join_description_with_discount: `— sammle Prämien wie bis zu <highlight>{{max_discount}} Rabatt</highlight> pro Bestellung`,
  join_description_with_product_and_discount: `— sammle Prämien wie Gratis {{product_name}} & bis zu <highlight>{{max_discount}} Rabatt</highlight> pro Bestellung`,
  demo_mode: 'Demo Modus',
};
